export const selectValueOnFocus = (e: React.FocusEvent<HTMLInputElement>) =>
  e?.target.select()
